import BuildingPageSettings from "./BuildingPageSettings";

export default BuildingPageSettings;
